<template>

<popup
    :button-style="adding ? 'primary' : 'success'"
    :heading="heading"
    size="medium"
    button-icon="fa fa-home"
    :centerButton="true"
    :buttonText="button"
    :disableButton="!isManager('property|finance') || readOnly || isViewOnly()"
    @save="onSaveDialog"
    @close="onCloseDialog">

    <update-tenancy
       ref="updateTenancy"
       :site-data="siteData"
       :tenancy-data="tData"
       :contact-data="cData"
       :adding="adding"
       :read-only="readOnly"
       @update="fireUpdate"
        />

</popup>

</template>



<script>

import UpdateTenancy from '@/components/property/UpdateTenancy'

export default {

  name: 'TenancyAction',

  components: {
    UpdateTenancy
  },

  props: {
    siteData: {
      type: Object,
      required: true
    },

    contactData: {
      type: Object,
      default: null
    },

    tenancyData: {
      type: Object,
      default: null
    },

    adding: {
      type: Boolean,
      default: false
    },

    readOnly: {
      type: Boolean,
      default: false
    }

  },


  methods: {
    onSaveDialog () {
      this.$refs.updateTenancy.onSaveDialog()
    },

    onCloseDialog () {
      this.$refs.updateTenancy.onCloseDialog()
    },

    fireUpdate (tenancy, adding = false) {
      this.$emit('update', tenancy, adding)
    }

  },


  computed: {

    heading: function () {
      return (this.adding ? 'Add Tenancy' : 'Update Tenancy')
    },

    button: function () {
      return (this.adding ? 'Add Tenancy' : 'Update')
    }

  },



  data () {
    return {
      tData: this.tenancyData,
      cData: this.contactData
    }
  }



}

</script>
